import commonService from 'utils/commonService';
import { QAClass } from 'constants/enums/qaClass.enum';
import apiService from '../apiService';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { BaseRes } from 'bff/models/base/baseRes';
import { Inscats, Codes, SysOptionReq, ServiceFAQs } from 'bff/models/info';
import { SysOptions } from 'bff/models/info/sysoptions';

/**
 * @description 取得客戶服務- e 化保單 初始頁面資料
 * @param qaClass QA 型別
*/
const fetchInitSetting = async (qaClass:QAClass) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const qaReq = commonService.getApiReqData({ QA_CLASS: qaClass });
  const sysOptionReq : SysOptionReq = {
    PCLASS: [SysOptType.TWCA_SW, SysOptType.TWCA_UG]
  };
  const sysReq = commonService.getApiReqData(sysOptionReq);

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchFAQ(qaReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.ePolicy),
    apiService.fetchSysOptions(sysReq, reqConfig)

  ]).then(([inscatRes, qaRes, ePolicyCodesRes, sysoptsRes]) => {
    const inscatBaseRes:BaseRes<Inscats> = { ...inscatRes };
    const qaBaseRes:BaseRes<ServiceFAQs> = { ...qaRes };
    const ePolicyCodesBaseRes:BaseRes<Codes> = { ...ePolicyCodesRes };
    const sysOptsBaseRes:BaseRes<SysOptions> = { ...sysoptsRes };

    const res = {
      inscats: commonService.arrayTypeReturn(inscatBaseRes.TRANRS.INSURANCE_CATEGORY),
      qaInfos: commonService.arrayTypeReturn(qaBaseRes.TRANRS.QA),
      ePolicyCodes: commonService.arrayTypeReturn(ePolicyCodesBaseRes.TRANRS.CODES),
      twcaSWSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptsBaseRes.TRANRS[SysOptType.TWCA_SW])),
      twcaUGSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptsBaseRes.TRANRS[SysOptType.TWCA_UG]))
    };
    return res;
  });

  return result;
};

export default {
  fetchInitSetting
};
